import React from "react";
import classes from "./priceSummary.module.css";
import { FaRupeeSign } from "react-icons/fa";

const getEstimatedTax = (applied_taxes = []) => {
  return {
    currency: applied_taxes[0].amount.currency,
    value: applied_taxes.reduce((acc, tax) => acc + tax.amount.value, 0),
  };
};

const TaxSummary = (props) => {
  const { data, isCheckout } = props;

  if (!data.length) {
    return null;
  }

  const taxLabel = isCheckout ? <span>Tax</span> : <span>Estimated Tax</span>;

  const tax = getEstimatedTax(props.data);

  return (
    <>
      <span className={classes.lineItemLabel}>{taxLabel}</span>
      <span className={classes.price}>
        <span>
          <FaRupeeSign />
          {tax.value}
        </span>
      </span>
    </>
  );
};

export default TaxSummary;
